module.exports = __webpack_public_path__ + "img/Zoom.fb654f9b.png";